<div class="dashboardWidgetContainer">
    <h2>{{ 'dashboard.scheduledChannelSnapshots.label' | translate }}</h2>
    @if (data && data.length > 0) {
        @if (columns && data) {
            <div class="gridWrapper">
                <app-data-grid [columns]="columns" [data]="data" />
            </div>
        }
    } @else {
        <div class="noDataText">
            <p>{{ 'dashboard.scheduledChannelSnapshots.noData' | translate }}</p>
        </div>
    }
    <footer>
        <button type="button" class="button primary hasIcon" (click)="openScheduledChannelSnapshotModal()">
            <i class="far fa-plus iconSmall"></i>
            {{ 'generalKeywords.add' | translate }}
        </button>
    </footer>
</div>
